<script>
  import { createEventDispatcher } from 'svelte'
  const dispatch = createEventDispatcher();

  export let checked;
  export let name;
  export let nested = false;
</script>

<label class="panel-block" class:child-category={nested}>
  <input type="checkbox" on:click={() => dispatch('check')} {checked}>
  <!-- {@debug category} -->
  {name}
</label>

<style>
  .child-category > input {
    margin-left: 1rem;
  }
  input {
    margin: 0;
    margin-right: 0.75rem;
  }
</style>